import React, { useEffect, useMemo, useState } from 'react';
import MaterialTable, { MTableBody, MTableToolbar } from 'material-table';
import { TableCell, TableRow, TableFooter } from '@material-ui/core';
import api from '../../api';
import { NavLink, useHistory } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import Select from 'react-select';
import { status_full_special as statusForBadge } from '../../helpers/factdata';
import { localization, modifyDefaultOptions } from '../../helpers/table';
import { years, tableIcons } from '../../helpers';
import { dateRenderer } from '../../services/formatSvc';
import { isAdminRead, isCommandManagmentOrProjOffice } from '../../services/rolesSvc';
import { ReceiptsProjectTableColumns, ProjectReceiptsColumns, NioktrReceiptsTabColumns, NioktrOwnFundsTabColumns, ReceiptsSPTableColumns, ReceiptsPortfTableColumns, PartReceiptTableColumns } from '../../columns/ColumnsReceipts';
import { renderNullFloatValues } from '../../pages/index/Shared';
import useToast from "../../hooks/useToast";
import LoadingTable from './LoadingTable';
import { isAdmin, isModerator, isStratAdmin, isStratCurator } from '../../services/rolesSvc';

import useUserContext from '../../hooks/useUserContext';

import '../Table.less';

import DownloadLink from '../common/DownloadLink';
import MTableFilterRow from '../material-table-overrides/MTableFilterRow';
import KpiHistoryModal from '../../pages/index/KpiHistoryModal';
import ModalEditReceipt from '../common/ModalEditReceipt';
import ConfirmModal from '../common/ConfirmModal';
import ModalSendForRevision from '../../components/common/ModalSendForRevision';
import ContractHistory from './ContractHistory';

const defaultYear = new Date().getFullYear();
const modifiedYears = [...years.map((val) => ({ value: val, label: val }))];

const properties = ['contractSum', 'contractSumWithShare', 'contractYearSum', 'contractYearSumWithShare', 'paymentOrderSum', 'paymentOrderSumWithShare', 'paymentActSum', 'paymentActSumWithShare', 'fbSum'];

const statusesOptions = [
  { value: '', label: 'Все статусы' },
  ...Object.entries(statusForBadge).map(([key, value]) => ({ value: key, label: value.label })),
];

export default function Receipts({portfolioId, projId, stratId, policyId, tableLeftValues, type, totalIndex, maxBodyHeight, strategyName, policyMode}) {
  const [actualData, setActualData] = useState();
  const [selYear, setSelYear] = useState({ value: defaultYear, label: defaultYear });
  const [selStatus, setSelStatus] = useState(statusesOptions[0]);
  const [showExcluded, setShowExcluded] = useState(false);
  const [isModalEdit, setIsModalEdit] = useState({ 
    show: false, 
    value: null, 
    resultValue: null, 
    subjectValue: null, 
    contractYearSum: null, 
    mainPerformer: undefined, 
    send: undefined, 
    year: null, 
    contractId: null, 
    projId: null, 
    projectsWithContract: [], 
    endDate: null, 
    status: null,
    policyId: null,
    strategyId: null,
    activityTypeId: null,
    activityTypeName: null
  });
  const [isModalDelete, setIsModalDelete] = useState({ 
    show: false, 
    policyId: undefined, 
    strategyId: undefined,
    projId: undefined, 
    contractPAId: undefined, 
    fullNumber: undefined, 
    name: undefined 
  });
  const [isModalReject, setIsModalReject] = useState({ 
    show: false, 
    projId: undefined, 
    contractId: undefined, 
    year: undefined
  });
  const [isModalExclude, setIsModalExclude] = useState({ 
    show: false, 
    projId: undefined, 
    contractId: undefined, 
    year: undefined, 
    exclude: false
  });
  const [isModalReturn, setIsModalReturn] = useState({ 
    show: false, 
    projId: undefined, 
    contractId: undefined, 
    year: undefined, 
    exclude: true
  });
  const [isModalHistory, setIsModalHistory] = useState({
    show: false, 
    contractId: undefined, 
  })
  const [historyModalReport, setHistoryModalReport] = useState(null);
  const [allTablesOpen, setAllTablesOpen] = useState(false);
  const [contragentCategories, setContragentCategories] = useState([]);
  const [statusesOptionsNew, setStatusesOptionsNew] = useState(statusesOptions.slice(0, -1));
  const [filterData, setFilterData] = useState([]);
  const [isLoaded, setIsLoaded] = useState(false);
  const [error, setError] = useState();
  const addToast = useToast();
  const history = useHistory();
  const userCtx = useUserContext();
  const leftValues = [48, ...tableLeftValues];

  // представители ответственных + ПО + АГ
  const canExport = () => userCtx.perms.includes('kpiAdmin') || isAdminRead(userCtx);
  const canAdd = useMemo(() => isCommandManagmentOrProjOffice(userCtx, stratId, projId, portfolioId), [userCtx, stratId, projId, portfolioId]) && ['projectReceipts', 'portfolioProjectReceipts', 'nioktrReceipts'].includes(type) || type === 'nioktrReceipts' && userCtx.perms.includes('moderator')
  // #endregion

  const roleModel = useMemo(() => ({
    canEdit: isAdmin(userCtx) || isModerator(userCtx) || isStratAdmin(userCtx, 4) || isStratCurator(userCtx, 4),
    canDelete: isAdmin(userCtx)
  }), [userCtx])

  const actions = {
    edit: (e) => callModalEdit(e, false),
    send: (e) => callModalEdit(e, true),
    approve: (e) => approveRequest(e),
    reject: (e) => setIsModalReject({ show: true, projId: e.projId, contractId: e.id, year: e.year }),
    exclude: (e) => setIsModalExclude({ show: true, projId: e.projId, contractId: e.id, year: e.year, exclude: true }),
    return: (e) => setIsModalReturn({ show: true, projId: e.projId, contractId: e.id, year: e.year, exclude: false }),
    checkHistory: (e) => setIsModalHistory({ show: true, contractId: e.id }),
  };

  const actionsParent = {
    edit: (e) => {
        const topicHead = e.personsInCharge.map((p) => `${p?.displayName}, ${p?.post}`).join(', ');
        type === 'nioktrReceipts' ? (
            localStorage.setItem('topicHead', topicHead),
            localStorage.setItem('headAccName', e.personsInCharge[0]?.sAMAccountName),
            localStorage.setItem('policyId', e.policyId),
            localStorage.setItem('strategyId', e.strategyId),
            localStorage.setItem('year', selYear.value),
            history.push(`/policies/${policyId}/budget/nioktr-receipts/${e.entityId}/edit-receipt`)
        ) : type === 'nioktrOwnFunds' ? (
            history.push(`/policies/${policyId}/budget/nioktr-own-funds/${e.id}/edit-receipt`)
        ) : (
            history.push(`${ stratId ? `/strats/${stratId}` : '' }${ portfolioId ? `/portfolios/${portfolioId}` : '' }${ projId ? `/projs/${projId}` : '' }/report/receipt/${e.entityId}/receipt-edit/`),
            localStorage.setItem('topic', e.topic),
            localStorage.setItem('headId', String(e.personsInCharge[0].id)),
            localStorage.setItem('headInstitute', e.personsInCharge[0].institute)
        )
        localStorage.setItem('topic', e.topic);
        localStorage.setItem('headInstitute', e.personsInCharge[0].institute);
    },
    delete: (e) => setIsModalDelete({ show: true, policyId: e.policyId, projId: e.projId, strategyId: e.strategy?.id, contractPAId: e.entityId, fullNumber: e.proj?.fullNumber, name: type === 'nioktrReceipts' ? strategyName : e.proj?.name }),
  };

  useEffect(async () => {
    const result = await getData(selYear.value);
    setActualData(convertData(result));
    FilterDataCreate(convertData(result));
    setIsLoaded(true)
    getContragentCategories();
  }, []);

  const handleInputChangeYear = async (val) => {
    const result = await getData(val.value, selStatus.value);
    setSelYear(val);
    setActualData(convertData(result));
    setAllTablesOpen(false);
  };

  const handleInputChangeStatus = async (val) => {
    const result = await getData(selYear.value, val.value === "excluded" ? "" : val.value, showExcluded);
    setSelStatus(val);
    setActualData(convertData(result).map((d) => ({ ...d, tableData: { isTreeExpanded: true } })).filter(e => val.value === "excluded" ? e.excluded : e));
    setAllTablesOpen(true);
  }

  const handleShowHiddenContracts = async () => {
    const result = await getData(selYear.value, selStatus.value === "excluded" ? "" : selStatus.value, !showExcluded);
    setStatusesOptionsNew(showExcluded ? statusesOptions.slice(0, -1) : statusesOptions)
    setShowExcluded(!showExcluded);
    setActualData(convertData(result).map((d) => ({ ...d, tableData: { isTreeExpanded: allTablesOpen } })).filter(e => selStatus.value === "excluded" ? e.excluded : e));
  }

  const switchColumns = (type) => {
    switch (type) {
      case 'projectReceipts': return ReceiptsProjectTableColumns(actualData, stratId, userCtx, actions, actionsParent, selYear.value, contragentCategories, handleSetActualData);
      case 'portfolioProjectReceipts': return ProjectReceiptsColumns(actualData, stratId, portfolioId, userCtx, actions, actionsParent, selYear.value, contragentCategories, handleSetActualData);
      case 'portfolioReceipts': return ReceiptsPortfTableColumns(actualData);
      case 'strategyProjectReceipts': return ReceiptsSPTableColumns(actualData);
      case 'allReceipts': return PartReceiptTableColumns(actualData, userCtx, actions, selYear.value, contragentCategories, handleSetActualData);
      case 'nioktrReceipts': return NioktrReceiptsTabColumns(actualData, policyId, roleModel, userCtx, actions, actionsParent, selYear.value, contragentCategories, handleSetActualData)
      case 'nioktrOwnFundsTab': return NioktrOwnFundsTabColumns(actualData, policyId, roleModel, userCtx, actionsParent)
    }
  }

  const handleValueChange = (value) => {
    setIsModalEdit((e) => ({
        ...e, value: value
    }))
  }

  const handleStateChange = (value) => {
    setIsModalEdit((e) => ({
        ...e, mainPerformer: value
    }))
  }

  const handleEndDateChange = (value) => {
    setIsModalEdit((e) => ({
        ...e, endDate: value
    }))
    handleSetActualData(actualData.filter((e) => e.tableData.isTreeExpanded));
  }

  const handleContractYearSumChange = (value) => {
    setIsModalEdit((e) => ({
      ...e, contractYearSum: value,
    }))
  };

  const handleActivityTypeChange = (id, name) => {
    setIsModalEdit((e) => ({
      ...e, activityTypeId: id, activityTypeName: name
    }))
  };

  const handleHideAllButton = () => {
    setActualData(actualData?.map((d) => ({ ...d, tableData: { isTreeExpanded: !allTablesOpen } })));
    setAllTablesOpen(!allTablesOpen);
  }

  const callModalEdit = async (e, value) => {
    let items = undefined;
    const result = await api.get(`/factdata/contracts/${e.id}/usage?year=${e.year}`);
    items = result;
    result?.hasOwnProperty('error')
    ? addToast.error(result.error.message)
    : (
        setIsModalEdit({ 
            show: true, 
            value: e.shareNew, 
            resultValue: e.result, 
            subjectValue: e.subject, 
            contractYearSum: e.contractYearSum, 
            mainPerformer: e.isPrimaryParticipant, 
            send: value, 
            year: e.year, 
            contractId: e.id, 
            projId: e.projId, 
            projectsWithContract: items ? items : [], 
            endDate: e.endDate, 
            status: e.statusNew || e.status,
            policyId: e.policyId,
            strategyId: e.strategyId,
            activityTypeId: e.activityTypeId,
            activityTypeName: e.activityTypeName
        })
    )
  }

  const handleSave = async (isSend) => {
    const policyOrProj = isModalEdit.policyId ? {
        policyId: isModalEdit.policyId,
    } : {
        strategyId: isModalEdit.strategyId,
    };
    const result = await api.post(`/factdata/contracts/${isModalEdit.contractId}/${isSend ? 'send' : 'share'}`, {
      ...policyOrProj,
      projId: isModalEdit.projId,
      contractId: isModalEdit.contractId,
      year: isModalEdit.year,
      share: isModalEdit.value / 100,
      isPrimaryParticipant: isModalEdit.mainPerformer,
      result: isModalEdit.resultValue,
      subject: isModalEdit.subjectValue,
      endDate: isModalEdit.endDate,
      contractYearSum: isModalEdit.contractYearSum,
      activityTypeId: isModalEdit.activityTypeId
    });
    result.hasOwnProperty('error')
    ? addToast.error(result.error.message)
    : (
      addToast.success(isSend ? 'Отправлено на согласование' : 'Поступление сохранено'),
      setActualData(actualData.map((el) => (
        el.hasOwnProperty('parentId') && el.id === isModalEdit.contractId ? 
            {
                ...el, 
                shareNew: isModalEdit.value, 
                isPrimaryParticipant: result.isPrimaryParticipant, 
                result: isModalEdit.resultValue, 
                subject: isModalEdit.subjectValue, 
                contractYearSum: isModalEdit.contractYearSum, 
                contractYearSumWithShare: isModalEdit.contractYearSum * isModalEdit.value / 100, 
                isPrimaryParticipantTitle: result.isPrimaryParticipant ? "Да" : "Нет", 
                statusNew: result.status,
                newEndDate: dateRenderer(isModalEdit.endDate), 
                endDate: isModalEdit.endDate,
                activityTypeId: isModalEdit.activityTypeId,
                activityTypeName: isModalEdit.activityTypeName,
            } 
        : 
            { ...el }
      ))),
      setIsModalEdit({ 
        show: false, 
        value: null, 
        resultValue: null, 
        subjectValue: null, 
        contractYearSum: null, 
        mainPerformer: undefined, 
        send: undefined, 
        year: null, 
        contractId: null, 
        projId: null, 
        projectsWithContract: [], 
        endDate: null, 
        status: null,
        policyId: null,
        strategyId: null,
        activityTypeId: null,
        activityTypeName: null,
      })
    )
  }

  const handleDelete = async () => {
    const result = await api.del(`/factdata/contracts/${isModalDelete.contractPAId}`, 
        type === 'nioktrReceipts' || type === 'nioktrOwnFundsTab' ? 
            {
                policyId: isModalDelete.policyId,
                strategyId: isModalDelete.strategyId,
                contractPAId: isModalDelete.contractPAId,
            } 
        : 
            {
                projId: isModalDelete.projId,
                contractPAId: isModalDelete.contractPAId
            }
    )
    const parentId = actualData.find(e => e.entityId === result.contractPAId).id;
    result.hasOwnProperty('error')
    ? addToast.error(`${result.error.message}, удаление невозможно`)
    : (
      addToast.success('Лицевой счет удален'),
      setActualData(actualData.filter((e) => (e.entityId !== result.contractPAId && e.parentId !== parentId))),
      setIsModalDelete({ 
        show: false, 
        policyId: undefined, 
        strategyId: undefined,
        projId: undefined, 
        contractPAId: undefined, 
        fullNumber: undefined, 
        name: undefined 
      })
    )
  }

  const approveRequest = async (e) => {
    const result = await api.post(`/factdata/contracts/${e.id}/approve`, {
      projId: e.projId,
      contractId: e.id,
      year: e.year
    })
    result.hasOwnProperty('error')
    ? addToast.error(result.error.message)
    : (
        addToast.success('Согласовано'),
        setActualData(actualData.map((el) => (el.hasOwnProperty('parentId') && el.id === e.id ? {...el, statusNew: result.status || el.status} : {...el})))
    )
  }

  const handleReject = async (comment) => {
    const result = await api.post(`/factdata/contracts/${isModalReject.contractId}/reject`, {
        projId: isModalReject.projId,
        contractId: isModalReject.contractId,
        year: isModalReject.year,
        comment: comment
    })
    result.hasOwnProperty('error')
    ? addToast.error(result.error.message)
    : (
      addToast.success('Не согласовано'),
      setActualData(actualData.map((e) => (e.hasOwnProperty('parentId') && e.id === isModalReject.contractId ? {...e, statusNew: result.status || el.status, comment: result.comment} : {...e}))),
      setIsModalReject({ 
        show: false, 
        projId: undefined, 
        contractId: undefined, 
        year: undefined 
      })
    )
  }

  const handleExclude = async () => {
    const result = await api.post(`/factdata/contracts/${isModalExclude.contractId}/exclude`, {
        projId: isModalExclude.projId,
        contractId: isModalExclude.contractId,
        year: isModalExclude.year,
        excluded: true,
    })
    result.hasOwnProperty('error')
    ? addToast.error(result.error.message)
    : (
      addToast.success('Исключено'),
      handleSetActualData(actualData.filter((e) => e.tableData?.isTreeExpanded)),
      setIsModalExclude({ 
        show: false, 
        projId: undefined, 
        contractId: undefined, 
        exclude: false 
      })
    )
  }

  const handleReturn = async () => {
    const result = await api.post(`/factdata/contracts/${isModalReturn.contractId}/exclude`, {
        projId: isModalReturn.projId,
        contractId: isModalReturn.contractId,
        year: isModalReturn.year,
        excluded: false,
    })
    result.hasOwnProperty('error')
    ? addToast.error(result.error.message)
    : (
      addToast.success('Возвращено в статус "Новый'),
      setActualData(actualData.map((e) => (e.hasOwnProperty('parentId') && e.id === isModalReturn.contractId ? {...e, statusNew: 'created'} : {...e}))),
      setIsModalReturn({ 
        show: false, 
        projId: undefined, 
        contractId: undefined, 
        exclude: false 
      })
    )
  }

  const getContragentCategories = async () => {
    const result = await api.get(`/mng/orgsCategories`);
    setContragentCategories(result.map(e => ({
      value: e.id,
      label: e.name,
    })))
  }

  const handleResultValueChange = (value) => {
    setIsModalEdit((e) => ({
      ...e, resultValue: value,
    }))
  };

  const handleSubjectValueChange = (value) => {
    setIsModalEdit((e) => ({
      ...e, subjectValue: value,
    }))
  };

  const FilterDataCreate = (result) => {
    let items = [];
    result?.filter((e) => !e.hasOwnProperty('parentId')).map((e) => {
      let item = {};
      e.personsInCharge?.forEach((e) => {
        item = {displayName: e.displayName, institute: e.institute}
      })
      items.push(item);
    })
    setFilterData(items);
  }

  const sumValues = (result) => {
    let sums = {};
    properties.forEach((item) => {
      let sumsOneArr = [];
      {result?.filter((e) => !e.hasOwnProperty('parentId')).map((e) => {
        sumsOneArr.push(e[item] === undefined ? 0 : e[item])
      })}
      if (sumsOneArr.length > 0)
      sums[item] = Number(sumsOneArr.reduce((a, b) => { return a + b }))
    })
    return sums;
  }

  const whichSign = () => {
    return projId ? `projId=${projId}` : portfolioId ? `portfId=${portfolioId}` : stratId ? `strategyId=${stratId}` : policyId ? `policyId=${policyId}` : ''
  }

  const getData = async (year, status, excluded) => {
    setIsLoaded(false);
    try {
        const yearQuery = year ? `&year=${year}` : '';
        const statusQuery = status ? `&status=${status}` : '';
        const excludedQuery = excluded ? `&showAll=${excluded}` : '';
        const policyQuery = policyMode ? '&mode=policy' : ''
        const result = await api.get(`/factdata/contracts?${whichSign()}${statusQuery}${yearQuery}${excludedQuery}${policyQuery}`);
        return result;
      } catch (error) {
        setError(error);
      } finally {
        setIsLoaded(true);
      }
  }

  const convertData = (value) => {
    const reformedResult = value.data.map(x => {
      return {
        ...{
            contragentName: x?.contractOrg?.title,
            contragentInn: x?.contractOrg?.inn,
            contragentCategory: x?.contractOrg?.category,
            topicHeads: x?.personsInCharge?.map((el) => el.displayName).join(', '),
            headsInstitute: x?.personsInCharge?.map((el) => el.institute).join(', '),
            actualType: x?.hasOwnProperty('parentId') ? x?.type : null,
            shareNew: x?.hasOwnProperty('share') ? x?.share * 100 : null,
            isPrimaryParticipantTitle: x?.isPrimaryParticipant === true ? 'Да' : x?.isPrimaryParticipant === false ? 'Нет' : '',
            paymentActsField: x?.paymentActs?.sort((a, b) => converterDate(a.paymentDate, b.paymentDate)).map((el) => `№ ${el?.num} от ${dateRenderer(el?.paymentDate)}`).join(',\n'),
            paymentOrdersField: x?.paymentOrders?.sort((a, b) => converterDate(a.paymentDate, b.paymentDate)).map((el) => `№ ${el?.num} от ${dateRenderer(el?.paymentDate)}`).join(',\n'),
            newRegDate: dateRenderer(x?.regDate),
            newEndDate: dateRenderer(x?.endDate),
            statusNew: x?.excluded ? 'excluded' : x?.status,
            projName: !x.hasOwnProperty('parentId') ? `${x?.proj?.fullNumber} ${x?.proj?.name}` : null,
            stratName: x?.proj?.strategyNum || x?.proj?.strategyName ? `${x?.proj?.strategyNum} ${x?.proj?.strategyName}` : null,
            headName: x?.proj?.head?.displayName,
            portfName: x?.proj?.portfName,
        }, ...x
      }
    });
    return reformedResult;
  }

  const handleSetActualData = async (data) => {
    const opened = data.map((e) => e.tableData.id);
    const result = await getData(selYear.value, selStatus.value);
    setActualData(convertData(result).map((e, index) => opened.includes(index) ? {...e, tableData: {...e.tableData, isTreeExpanded: true}} : e));
  };

  const converterDate = (a, b) => {
    return b?.substring(0, 10).replace(/-/g, '') - a?.substring(0, 10).replace(/-/g, '')
  }

  const yearForDownloadDoc = (year) => {
    return year ? `&year=${JSON.stringify(year)}` : '';
  }

  const statusForDownloadDoc = (status) => {
    return status ? `&status=${status}` : '';
  }

  const portfIdForDownloadDoc = (portfId) => {
    return portfId ? `&portfId=${portfId}` : '';
  }

  const projIdForDownloadDoc = (projId) => {
    return projId ? `&projId=${projId}` : '';
  }

  const policyIdForDownloadDoc = (policyId) => {
    return policyId ? `&policyId=${policyId}` : '';
  }

  const strategyIdForDownloadDoc = (strategyId) => {
    return strategyId ? `&strategyId=${strategyId}` : '';
  }

  const theTable = useMemo(() => 
  <MaterialTable
    options={modifyDefaultOptions({
        columnsButton: true,
        maxBodyHeight: maxBodyHeight || 'calc(100vh - 400px)',
        rowStyle: (rowData) => ({
        backgroundColor: !rowData.parentId ? '#f5f5ff' : '#FFF',
        whiteSpace: 'pre-wrap',
        }),
        paging: false,
        headerStyle: {
          height: 72,
          position: 'sticky',
          left: 0
        },
        filterCellStyle: {
          position: 'sticky',
          left: 0,
          top: 72,
          background: 'white',
          maxWidth: 300
        },
    })}
    icons={tableIcons}
    localization={localization}
    columns={switchColumns(type)}
    data={actualData}
    components={{
        FilterRow: (props) => {
            return <MTableFilterRow {...props} />
        },
        Body: (props) => {
            return <>
                <MTableBody {...props} />
                {props.renderData.length > 0 && <TableFooter>
                <TableRow>
                    <TableCell 
                        style={{
                            boxShadow: 'rgba(0, 0, 0, 0.15) 5px 0px 5px', 
                            bottom: 0
                        }}
                    ></TableCell>
                    {props.columns.filter((column) => !column.hidden).map((column, index) => (
                    <TableCell
                        style={
                            index > totalIndex ? 
                                {
                                    color: '#212529', 
                                    fontWeight: 700, 
                                    fontSize: 14,
                                    position: 'sticky',
                                    background: 'white',
                                    boxShadow: 'rgba(0, 0, 0, 0.15) 5px 0px 5px',
                                    bottom: 0
                                }
                            :   
                                {
                                    color: '#212529', 
                                    fontWeight: 700, 
                                    fontSize: 14, 
                                    position: 'sticky', 
                                    left: (leftValues[index]), 
                                    background: 'white', 
                                    boxShadow: 'rgba(0, 0, 0, 0.15) 5px 0px 5px', 
                                    zIndex: 15,
                                    bottom: 0
                                }
                        }
                        key={index}
                    >
                        {index === totalIndex ? 'Итого' : properties.includes(column.field) ? renderNullFloatValues(sumValues(props.renderData)[column.field]) : ""}
                    </TableCell>
                    ))}
                </TableRow>
                </TableFooter>}
            </>

        },
        Toolbar: (props) => (
        <div style={{marginBottom: 24}}>
            <div style={styledToolbarContainer}>
                <div style={{display: 'flex'}}>
                    <div style={styledToolbar}>
                        <div style={styledToolbarTitles}>Год</div>
                        <Select
                            placeholder="Выберите год"
                            defaultValue={[{ value: defaultYear, label: defaultYear }]}
                            name="yearsSingle"
                            options={modifiedYears}
                            onChange={handleInputChangeYear}
                            value={selYear}
                            isSearchable={false}
                        />
                    </div>
                    {type !== 'nioktrReceipts' && <div style={{ minWidth: '200px', marginLeft: '16px', zIndex: 100 }}>
                        <div style={styledToolbarTitles}>Статус</div>
                        <Select
                            defaultValue={selStatus}
                            options={statusesOptionsNew}
                            onChange={handleInputChangeStatus}
                        />
                    </div>}
                </div>
            <div style={{display: 'flex', alignItems: 'center'}}>
                {['projectReceipts', 'portfolioProjectReceipts', 'nioktrReceipts'].includes(type) && <div style={{ width: '430px', marginRight: 20, textAlign: 'right' }}>
                    <button style={{display: 'inline-flex', border: 'none', backgroundColor: 'transparent', color: '#0D6EFD', fontSize: 16,  fontWeight: 700, fontFamily: 'Open-sans, sans-serif', padding: 0, columnGap: 10}} onClick={handleShowHiddenContracts}>
                    {showExcluded ? 'Не отображать ' : 'Отобразить '}
                    скрытые договоры/лицевые счета
                    <svg width="16" height="9" viewBox="0 0 16 9" fill="none" xmlns="http://www.w3.org/2000/svg" transform={showExcluded ? "rotate(180), translate(0, -8)" : "rotate(0), translate(0, 8)"}>
                        <path d="M1 1.5L8 7.5L15 1.5" stroke="#0D6EFD" strokeWidth="2"/>
                    </svg>
                    </button>
                </div>}
                <div style={{ width: '150px', marginRight: 20, textAlign: 'right' }}>
                    <button style={{display: 'inline-flex', border: 'none', backgroundColor: 'transparent', color: '#0D6EFD', fontSize: 16,  fontWeight: 700, fontFamily: 'Open-sans, sans-serif', padding: 0, columnGap: 10}} onClick={handleHideAllButton}>
                    {allTablesOpen ? 'Свернуть ' : 'Развернуть '}
                    все
                    <svg width="16" height="9" viewBox="0 0 16 9" fill="none" xmlns="http://www.w3.org/2000/svg" transform={allTablesOpen ? "rotate(180), translate(0, -8)" : "rotate(0), translate(0, 8)"}>
                        <path d="M1 1.5L8 7.5L15 1.5" stroke="#0D6EFD" strokeWidth="2"/>
                    </svg>
                    </button>
                </div>
                <div>
                    <MTableToolbar {...props} />
                </div>
                {canExport && (
                    <div style={{ flex: 'none', marginLeft: 16 }}>
                    <DownloadLink
                        variant="outline-primary"
                        url={`/factdata/contracts/0/export?${strategyIdForDownloadDoc(stratId)}${policyIdForDownloadDoc(policyId)}${portfIdForDownloadDoc(portfolioId)}${projIdForDownloadDoc(projId)}${statusForDownloadDoc(selStatus.value)}${yearForDownloadDoc(selYear.value)}`}
                        filename={`Отчет по поступлениям_${dateRenderer(new Date())}.xlsx`}
                    >
                        Выгрузить в Excel
                    </DownloadLink>
                    </div>
                )}
                {canAdd && (<div style={{ flex: 'none', marginLeft: 16 }}>
                    <NavLink to={type === 'nioktrReceipts' ? `/policies/${policyId}/budget/nioktr-receipts/new-receipt?year=${selYear.label}` : `${ stratId ? `/strats/${stratId}` : '' }${ portfolioId ? `/portfolios/${portfolioId}` : '' }${ projId ? `/projs/${projId}` : '' }/report/nreceipt/new-contract?year=${selYear.label}`}>
                        <Button variant="primary">+ Добавить</Button>
                    </NavLink>
                </div>)}
            </div>
            </div>
        </div>
        ),
    }}
    title=""
    parentChildData={(row, rows) =>
        rows.find((a) => a.id === row.parentId)}
  />, [actualData, maxBodyHeight, tableIcons, localization, type, modifyDefaultOptions, totalIndex, properties, renderNullFloatValues, modifiedYears, selYear, selStatus, statusesOptionsNew, showExcluded])

  return (
    <LoadingTable spinnerStyle={{ marginTop: '50px' }} loadingObject={{ isLoaded }}>
        <section className="">
        <div style={styledTable} className='table-with-parentChildData'>
            {type !== 'nioktrReceipts' && <h3 style={styledTitle}>Реестр поступлений</h3>}
            {theTable}
        </div>
        <ModalEditReceipt
            isSend={isModalEdit.send}
            show={isModalEdit.show}
            projId={isModalEdit.projId}
            value={Number(isModalEdit.value)}
            mainPerformer={isModalEdit.mainPerformer}
            projectsWithContract={isModalEdit.projectsWithContract}
            resultValue={isModalEdit.resultValue}
            status={isModalEdit.status}
            onClose={() => setIsModalEdit({ 
                show: false, 
                value: null, 
                resultValue: undefined, 
                mainPerformer: undefined, 
                send: undefined, 
                contractId: null, 
                projId: null, 
                projectsWithContract: [],  
                status: null,
            })}
            onSave={(e) => handleSave(e)}
            onStateChange={(e) => handleStateChange(e)}
            onValueChange={(e) => handleValueChange(e)}
            onResultValueChange={(e) => handleResultValueChange(e)}
            showResultField
        />
        <ConfirmModal
            show={isModalDelete.show}
            onClose={() => setIsModalDelete({ 
                show: false, 
                policyId: undefined, 
                strategyId: undefined,
                projId: undefined, 
                contractPAId: undefined, 
                fullNumber: undefined, 
                name: undefined
            })}
            onConfirm={handleDelete}
            headerText="Удаление лицевого счета"
            message={`Вы действительно хотите удалить связь лицевого счета с проектом ${isModalDelete.fullNumber ? `${isModalDelete.fullNumber} ` : ""}${isModalDelete.name}?`}
        />
        <ConfirmModal
            show={isModalExclude.show}
            onClose={() => setIsModalExclude({ 
                show: false, 
                projId: undefined, 
                contractPAId: undefined, 
                year: undefined, 
                exclude: false 
            })}
            onConfirm={handleExclude}
            headerText="Не относить к проекту"
            message={`Не относить к проекту?`}
        />
        <ConfirmModal
            show={isModalReturn.show}
            onClose={() => setIsModalReturn({ 
                show: false, 
                projId: undefined, 
                contractPAId: undefined, 
                year: undefined, 
                exclude: true 
            })}
            onConfirm={handleReturn}
            headerText="Вернуть в статус Новый"
            message={`Вернуть в статус Новый?`}
        />
        <ModalSendForRevision
            show={isModalReject.show}
            onClose={() => setIsModalReject({ 
                show: false, 
                projId: undefined, 
                contractId: undefined, 
                year: undefined 
            })}
            onSubmit={(comment) => handleReject(comment)}
            headerText="Отказ в согласовании договора"
            label="Комментарий"
        />
        <ContractHistory show={isModalHistory.show} contractId={isModalHistory.contractId} onHide={() => setIsModalHistory({show: false, contractId: undefined})}/>
        {historyModalReport && <KpiHistoryModal report={historyModalReport} onClose={() => setHistoryModalReport(null)} />}
        </section>
    </LoadingTable>
  );
}

const styledTable = {
  maxWidth: '100%',
  marginTop: 20,
};
const styledToolbarContainer = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
};
const styledToolbar = {
  flex: 'none',
  zIndex: 100,
}
const styledTitle = {
  marginBottom: 20,
  fontSize: 20,
  textAlign: 'start',
};
const styledToolbarTitles = {
  color: 'black',
  fontSize: '16px',
  marginBottom: '10px',
  fontWeight: '600',
};
